export const backendURL = process.env.REACT_APP_BACKEND_ENDPOINT;
export const frontendURL = process.env.REACT_APP_FRONTEND_ENDPOINT;
export const assetsURL = process.env.REACT_APP_ASSETS_ENDPOINT;